import { useMemo } from 'react'
import { useProjectFilter } from '../contexts/ProjectFilterContext'

interface ProjectData {
  documents: {
    valid: number
    expired: number
    expiringSoon: number
  }
  inspections: {
    todayIncomplete: number
    todayTotal: number
    weekIncomplete: number
    weekTotal: number
  }
  preShifts: {
    todayIncomplete: number
    todayTotal: number
    weekIncomplete: number
    weekTotal: number
  }
  toolboxTalk: {
    thisWeekIncomplete: number
    thisWeekTotal: number
    previousWeekIncomplete: number
    previousWeekTotal: number
  }
  jha: {
    entireProjectsIncomplete: number
    entireProjectsTotal: number
    thisWeekIncomplete: number
    thisWeekTotal: number
  }
  ptp: {
    todayIncomplete: number
    todayTotal: number
    thisWeekIncomplete: number
    thisWeekTotal: number
  }
  observations: {
    lifeThreading: number
    major: number
    moderate: number
    minor: number
    resolved: number
  }
  workers: {
    present: number
    safetyOrientation: number
    oshaAct: number
    mandatoryDocuments: number
  }
}

const PROJECT_DATA: Record<string, ProjectData> = {
  'Court Square LIC': {
    documents: { valid: 15, expired: 20, expiringSoon: 8 },
    inspections: {
      todayIncomplete: 1,
      todayTotal: 3,
      weekIncomplete: 2,
      weekTotal: 8,
    },
    preShifts: {
      todayIncomplete: 3,
      todayTotal: 4,
      weekIncomplete: 18,
      weekTotal: 20,
    },
    toolboxTalk: {
      thisWeekIncomplete: 0,
      thisWeekTotal: 0,
      previousWeekIncomplete: 1,
      previousWeekTotal: 1,
    },
    jha: {
      entireProjectsIncomplete: 1,
      entireProjectsTotal: 18,
      thisWeekIncomplete: 1,
      thisWeekTotal: 1,
    },
    ptp: {
      todayIncomplete: 1,
      todayTotal: 1,
      thisWeekIncomplete: 2,
      thisWeekTotal: 3,
    },
    observations: {
      lifeThreading: 0,
      major: 1,
      moderate: 0,
      minor: 1,
      resolved: 8,
    },
    workers: {
      present: 145,
      safetyOrientation: 8,
      oshaAct: 2,
      mandatoryDocuments: 85,
    },
  },
  '99 Claremont Ave': {
    documents: { valid: 12, expired: 18, expiringSoon: 7 },
    inspections: {
      todayIncomplete: 0,
      todayTotal: 2,
      weekIncomplete: 1,
      weekTotal: 6,
    },
    preShifts: {
      todayIncomplete: 2,
      todayTotal: 3,
      weekIncomplete: 15,
      weekTotal: 18,
    },
    toolboxTalk: {
      thisWeekIncomplete: 0,
      thisWeekTotal: 0,
      previousWeekIncomplete: 0,
      previousWeekTotal: 0,
    },
    jha: {
      entireProjectsIncomplete: 1,
      entireProjectsTotal: 15,
      thisWeekIncomplete: 0,
      thisWeekTotal: 0,
    },
    ptp: {
      todayIncomplete: 1,
      todayTotal: 1,
      thisWeekIncomplete: 1,
      thisWeekTotal: 2,
    },
    observations: {
      lifeThreading: 0,
      major: 0,
      moderate: 1,
      minor: 0,
      resolved: 2,
    },
    workers: {
      present: 98,
      safetyOrientation: 5,
      oshaAct: 1,
      mandatoryDocuments: 62,
    },
  },
  '251 Douglass Street': {
    documents: { valid: 18, expired: 22, expiringSoon: 10 },
    inspections: {
      todayIncomplete: 1,
      todayTotal: 2,
      weekIncomplete: 2,
      weekTotal: 7,
    },
    preShifts: {
      todayIncomplete: 4,
      todayTotal: 5,
      weekIncomplete: 20,
      weekTotal: 22,
    },
    toolboxTalk: {
      thisWeekIncomplete: 1,
      thisWeekTotal: 1,
      previousWeekIncomplete: 1,
      previousWeekTotal: 1,
    },
    jha: {
      entireProjectsIncomplete: 1,
      entireProjectsTotal: 20,
      thisWeekIncomplete: 1,
      thisWeekTotal: 1,
    },
    ptp: {
      todayIncomplete: 1,
      todayTotal: 1,
      thisWeekIncomplete: 1,
      thisWeekTotal: 2,
    },
    observations: {
      lifeThreading: 0,
      major: 0,
      moderate: 0,
      minor: 0,
      resolved: 0,
    },
    workers: {
      present: 178,
      safetyOrientation: 12,
      oshaAct: 3,
      mandatoryDocuments: 112,
    },
  },
  'Site B': {
    documents: { valid: 5, expired: 8, expiringSoon: 5 },
    inspections: {
      todayIncomplete: 0,
      todayTotal: 1,
      weekIncomplete: 1,
      weekTotal: 4,
    },
    preShifts: {
      todayIncomplete: 1,
      todayTotal: 2,
      weekIncomplete: 10,
      weekTotal: 12,
    },
    toolboxTalk: {
      thisWeekIncomplete: 0,
      thisWeekTotal: 0,
      previousWeekIncomplete: 0,
      previousWeekTotal: 0,
    },
    jha: {
      entireProjectsIncomplete: 0,
      entireProjectsTotal: 8,
      thisWeekIncomplete: 0,
      thisWeekTotal: 1,
    },
    ptp: {
      todayIncomplete: 0,
      todayTotal: 1,
      thisWeekIncomplete: 1,
      thisWeekTotal: 1,
    },
    observations: {
      lifeThreading: 0,
      major: 0,
      moderate: 0,
      minor: 0,
      resolved: 0,
    },
    workers: {
      present: 85,
      safetyOrientation: 4,
      oshaAct: 1,
      mandatoryDocuments: 52,
    },
  },
  '450 Park Avenue South': {
    documents: { valid: 5, expired: 8, expiringSoon: 5 },
    inspections: {
      todayIncomplete: 0,
      todayTotal: 1,
      weekIncomplete: 1,
      weekTotal: 4,
    },
    preShifts: {
      todayIncomplete: 1,
      todayTotal: 2,
      weekIncomplete: 10,
      weekTotal: 12,
    },
    toolboxTalk: {
      thisWeekIncomplete: 0,
      thisWeekTotal: 0,
      previousWeekIncomplete: 0,
      previousWeekTotal: 0,
    },
    jha: {
      entireProjectsIncomplete: 0,
      entireProjectsTotal: 8,
      thisWeekIncomplete: 0,
      thisWeekTotal: 1,
    },
    ptp: {
      todayIncomplete: 0,
      todayTotal: 1,
      thisWeekIncomplete: 1,
      thisWeekTotal: 1,
    },
    observations: {
      lifeThreading: 0,
      major: 0,
      moderate: 0,
      minor: 0,
      resolved: 0,
    },
    workers: {
      present: 85,
      safetyOrientation: 4,
      oshaAct: 1,
      mandatoryDocuments: 52,
    },
  },
  '520 Fifth Avenue': {
    documents: { valid: 3, expired: 4, expiringSoon: 3 },
    inspections: {
      todayIncomplete: 0,
      todayTotal: 0,
      weekIncomplete: 0,
      weekTotal: 2,
    },
    preShifts: {
      todayIncomplete: 1,
      todayTotal: 2,
      weekIncomplete: 6,
      weekTotal: 6,
    },
    toolboxTalk: {
      thisWeekIncomplete: 0,
      thisWeekTotal: 0,
      previousWeekIncomplete: 0,
      previousWeekTotal: 0,
    },
    jha: {
      entireProjectsIncomplete: 0,
      entireProjectsTotal: 6,
      thisWeekIncomplete: 0,
      thisWeekTotal: 0,
    },
    ptp: {
      todayIncomplete: 0,
      todayTotal: 0,
      thisWeekIncomplete: 0,
      thisWeekTotal: 0,
    },
    observations: {
      lifeThreading: 0,
      major: 0,
      moderate: 0,
      minor: 0,
      resolved: 0,
    },
    workers: {
      present: 85,
      safetyOrientation: 3,
      oshaAct: 1,
      mandatoryDocuments: 48,
    },
  },
}

export function useDashboardData() {
  const { selectedProjects } = useProjectFilter()

  const aggregatedData = useMemo(() => {
    const data: ProjectData = {
      documents: { valid: 0, expired: 0, expiringSoon: 0 },
      inspections: {
        todayIncomplete: 0,
        todayTotal: 0,
        weekIncomplete: 0,
        weekTotal: 0,
      },
      preShifts: {
        todayIncomplete: 0,
        todayTotal: 0,
        weekIncomplete: 0,
        weekTotal: 0,
      },
      toolboxTalk: {
        thisWeekIncomplete: 0,
        thisWeekTotal: 0,
        previousWeekIncomplete: 0,
        previousWeekTotal: 0,
      },
      jha: {
        entireProjectsIncomplete: 0,
        entireProjectsTotal: 0,
        thisWeekIncomplete: 0,
        thisWeekTotal: 0,
      },
      ptp: {
        todayIncomplete: 0,
        todayTotal: 0,
        thisWeekIncomplete: 0,
        thisWeekTotal: 0,
      },
      observations: {
        lifeThreading: 0,
        major: 0,
        moderate: 0,
        minor: 0,
        resolved: 0,
      },
      workers: {
        present: 0,
        safetyOrientation: 0,
        oshaAct: 0,
        mandatoryDocuments: 0,
      },
    }

    selectedProjects.forEach((projectName) => {
      const projectData = PROJECT_DATA[projectName]
      if (!projectData) return

      // Documents
      data.documents.valid += projectData.documents.valid
      data.documents.expired += projectData.documents.expired
      data.documents.expiringSoon += projectData.documents.expiringSoon

      // Inspections
      data.inspections.todayIncomplete +=
        projectData.inspections.todayIncomplete
      data.inspections.todayTotal += projectData.inspections.todayTotal
      data.inspections.weekIncomplete += projectData.inspections.weekIncomplete
      data.inspections.weekTotal += projectData.inspections.weekTotal

      // Pre-Shifts
      data.preShifts.todayIncomplete += projectData.preShifts.todayIncomplete
      data.preShifts.todayTotal += projectData.preShifts.todayTotal
      data.preShifts.weekIncomplete += projectData.preShifts.weekIncomplete
      data.preShifts.weekTotal += projectData.preShifts.weekTotal

      // Toolbox Talk
      data.toolboxTalk.thisWeekIncomplete +=
        projectData.toolboxTalk.thisWeekIncomplete
      data.toolboxTalk.thisWeekTotal += projectData.toolboxTalk.thisWeekTotal
      data.toolboxTalk.previousWeekIncomplete +=
        projectData.toolboxTalk.previousWeekIncomplete
      data.toolboxTalk.previousWeekTotal +=
        projectData.toolboxTalk.previousWeekTotal

      // JHA
      data.jha.entireProjectsIncomplete +=
        projectData.jha.entireProjectsIncomplete
      data.jha.entireProjectsTotal += projectData.jha.entireProjectsTotal
      data.jha.thisWeekIncomplete += projectData.jha.thisWeekIncomplete
      data.jha.thisWeekTotal += projectData.jha.thisWeekTotal

      // PTP
      data.ptp.todayIncomplete += projectData.ptp.todayIncomplete
      data.ptp.todayTotal += projectData.ptp.todayTotal
      data.ptp.thisWeekIncomplete += projectData.ptp.thisWeekIncomplete
      data.ptp.thisWeekTotal += projectData.ptp.thisWeekTotal

      // Observations
      data.observations.lifeThreading += projectData.observations.lifeThreading
      data.observations.major += projectData.observations.major
      data.observations.moderate += projectData.observations.moderate
      data.observations.minor += projectData.observations.minor
      data.observations.resolved += projectData.observations.resolved

      // Workers
      data.workers.present += projectData.workers.present
      data.workers.safetyOrientation += projectData.workers.safetyOrientation
      data.workers.oshaAct += projectData.workers.oshaAct
      data.workers.mandatoryDocuments += projectData.workers.mandatoryDocuments
    })

    return data
  }, [selectedProjects])

  return aggregatedData
}
